import { LoadingSpinner } from '@ecomm/checkout-icons'
import { proSetupQueryParam } from '@ecomm/data-constants'
import { useLocale } from '@ecomm/data-hooks'
import { brazeSetCustomUserAttributes } from '@ecomm/tracking'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'

import { PriceProvider } from '@ecomm/data-price'
import { useGuidedSystemBuilderCaptureLeadAndTrack } from '@ecomm/home-landing-data'
import {
  Installation,
  QueryParams,
  getAttributeHashToItemCount
} from '@ecomm/home-landing-data'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import { useEffect } from 'react'

function QuizRecommendedSystemWrapper() {
  const locale = useLocale()

  return (
    <PriceProvider
      locale={locale}
      skus={['simplisafe-custom-home-security-system-en-US']}
    >
      <QuizRecommendedSystem />
    </PriceProvider>
  )
}

function QuizRecommendedSystem() {
  const location = useLocation()
  const locale = useLocale()

  const [
    leadGenError,
    leadGenResponse,
    trackLeadCaptureCompleted,
    dynamicHashResponse
  ] = useGuidedSystemBuilderCaptureLeadAndTrack()

  const params = new URLSearchParams(location.search)
  const isProInstallSelectedInQuiz =
    params.get(QueryParams.installation) === Installation.ProInstall

  useEffect(() => {
    pipe(
      dynamicHashResponse,
      O.map(({ attributeHash }) => {
        const dynamicURL = `/product/system/${attributeHash}${
          isProInstallSelectedInQuiz ? `?${proSetupQueryParam}` : ''
        }`
        // Track product name into Braze
        brazeSetCustomUserAttributes({
          QW_RECS_PRODUCT_NAME: `${getAttributeHashToItemCount(
            attributeHash,
            locale
          )}-Piece Security System`
        })
        navigate(dynamicURL)
      })
    )
  }, [
    trackLeadCaptureCompleted,
    leadGenResponse,
    isProInstallSelectedInQuiz,
    locale,
    dynamicHashResponse
  ])

  return leadGenError ? (
    <div className="flex flex-col items-center pb-16 pt-24">
      <h2>Something went wrong.</h2>
      <p>
        <a href="/build-my-system">Create your own system instead </a>
      </p>
    </div>
  ) : (
    <div className="flex flex-col items-center pb-16 pt-24">
      <h2>Loading your package…</h2>
      <LoadingSpinner fillColor="#f79e00" size={48} />
    </div>
  )
}

export { QuizRecommendedSystemWrapper as QuizRecommendedSystem }
